import { render, staticRenderFns } from "./SelectSimple.vue?vue&type=template&id=47e2edd8&scoped=true"
import script from "./SelectSimple.vue?vue&type=script&lang=js"
export * from "./SelectSimple.vue?vue&type=script&lang=js"
import style0 from "./SelectSimple.vue?vue&type=style&index=0&id=47e2edd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2edd8",
  null
  
)

export default component.exports